/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

App Content Plugin Pagination

*/

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

function initPagination() {
    $('.app-content-pagination').each(function() {
        const $pagination = $(this);
        const $appContentPlugin = $pagination.parent().find('.app-content-plugin');
        const $smoothScrollHeader = $('.smooth-scroll-header-compact-mode-size');
        const $ajaxItemsContainer = $pagination.parent().find('.ajax-items-container');
        const $prev = $pagination.find('.app-content-pagination__prev');
        const $next = $pagination.find('.app-content-pagination__next');
        const $currentPage = $pagination.find('.app-content-pagination__current__number');
        const $paginationLinks = $pagination.find('.app-content-pagination__link');
        const pluginId = $pagination.data('plugin-id');
        let pageChangingTimer = null;

        function togglePaginationLinks($element, url) {
            if (url) {
                $element.children('.app-content-pagination__link').attr('href', url);
                $element.children('.app-content-pagination__link').removeClass('app-content-pagination__link--disabled');
            } else {
                $element.children('.app-content-pagination__link').addClass('app-content-pagination__link--disabled');
            }
        }

        function handlePageChange(url) {
            $.ajax({
               url,
            }).done(function(response) {
                const { data, next, prev, page } = response;

                // scroll to top of app-content-plugin container
                const { top } = $appContentPlugin.offset();
                const scrollPosition = top - $smoothScrollHeader.height();
                window.scroll({
                    left: 0,
                    top: scrollPosition,
                    behavior: 'smooth'
                });

                // wait a bit for scrolling animation
                setTimeout(() => {
                    // replace content
                    $ajaxItemsContainer.html(data);

                    // update pagination links urls
                    togglePaginationLinks($next, next);
                    togglePaginationLinks($prev, prev);

                    // set current page number
                    $currentPage.val(page);

                }, 500);

            });
        }

        function handlePageChangeInput(value, element) {
            const page = Number(value);
            const min = Number(element.attr('min'));
            const max = Number(element.attr('max'));

            if (page && (page <= max) && (page >= min)) {
                const url = `page/${page}?plugin_id=${pluginId}`;
                handlePageChange(url);
            }
        }

        // handle pagination link clicks
        $paginationLinks.on('click', function(e) {
            e.preventDefault();

            const url = $(this).attr('href');
            handlePageChange(url);

        });

        // handle input field change
        $currentPage.on('keyup', function(e) {
            clearTimeout(pageChangingTimer);
            pageChangingTimer = setTimeout(() => {
                handlePageChangeInput(e.target.value, $(this));
            }, 400);
        });
    });
}

$(function (){

    initPagination();

});



// WEBPACK FOOTER //
// ./static/js/modules/pagination.js